module.exports = __webpack_public_path__ + "img/kong.7df63f12.svg";